import CheckboxTree from 'react-checkbox-tree';
import React from 'react';
import PropTypes from 'prop-types';
import AllSelector from '../../AllSelector';
import noop from '../../tools/noop';

const CheckboxTreeSelector = (props) => {
  const {
    title = 'title',
    onSelectAll = noop,
    onDeSelectAll = noop,
    nodes = [],
    expanded = [],
    checked = [],
    onCheck = noop,
    onExpand = noop,
    expandDisabled = false,
    allSelectorDisabled = false,
    appContextType = '',
    onContextClick = noop,
  } = props;

  return (
    <div className="selector-wrapper">
      {allSelectorDisabled === false
      && (
        <div className="selector-header">
          <h4 className="selector-title">{title}</h4>
          <AllSelector
            className="all-selector"
            onSelectAll={onSelectAll}
            onDeSelectAll={onDeSelectAll}
            appContextType={appContextType}
            onContextClick={onContextClick}
          />
        </div>
      )}
      <div className="selector-list">
        <CheckboxTree
          nodes={nodes}
          checked={checked}
          expanded={expanded}
          onCheck={onCheck}
          onExpand={onExpand}
          showNodeIcon={false}
          expandDisabled={expandDisabled}
        />
      </div>
    </div>
  );
};
CheckboxTreeSelector.propTypes = {
  title: PropTypes.string,
  checked: PropTypes.arrayOf(PropTypes.string),
  expanded: PropTypes.arrayOf(PropTypes.string),
  nodes: PropTypes.arrayOf(PropTypes.object),
  onSelectAll: PropTypes.func,
  onDeSelectAll: PropTypes.func,
  onCheck: PropTypes.func,
  onExpand: PropTypes.func,
  expandDisabled: PropTypes.bool,
  allSelectorDisabled: PropTypes.bool,
  appContextType: PropTypes.string,
  onContextClick: PropTypes.func,
};
export default CheckboxTreeSelector;
